import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './PotNotFound.module.scss';

const PotNotFound = () => {
    const { t } = useTranslateLpc(['common']);
    return (
        <div className={css.wrapper}>
            <img className={css.eyes} src={`/front-static/images/error/404-eyes.svg`} alt="eyes" />
            <Text variant={'tagline'} color={'brand-primary'}>
                {t('page-not-found.oops')}
            </Text>
            <h1 className={css.title}>{t('page-not-found.pot-not-available')}</h1>
            <Text customClass={css.desc} variant={'body_02'} color={'ui-secondary'}>
                {t('page-not-found.pot-not-available-desc')}
            </Text>
            <Link href={getRoute(ROUTE.LPC.HOME)}>
                <Button onClick={() => {}} variant={'primary'} customClass={css.return_button}>
                    {t('page-not-found.return')}
                </Button>
            </Link>
        </div>
    );
};
export default PotNotFound;
